import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select from '@material/react-select';
import Carousel from 'nuka-carousel';
import {//Headline4,
        Headline5,
    Headline6,
   // Subtitle1,
   // Subtitle2
} from '@material/react-typography';

import RankAndMagnitudeChart from '../RankAndMagnitudeChart/RankAndMagnitudeChart';
import '../../Components/RankAndMagnitudeChart/RankAndMagnitudeChart';
import { ThemeContext } from '../../themeContext';

class  XDashboardContainer extends Component {

    static propTypes = {
        data: PropTypes.array.isRequired,
        itemsToRankCols: PropTypes.array.isRequired,
        dimensions: PropTypes.object.isRequired,
        col:  PropTypes.object.isRequired,
        dimensionLabels:  PropTypes.object.isRequired,
        isMediumScreen: PropTypes.bool.isRequired,
        isLargeScreen: PropTypes.bool.isRequired,
        dashboardTitle:  PropTypes.string.isRequired,
        overallChartTitle:  PropTypes.string.isRequired,
        dimensionChartsTitle: PropTypes.string.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            dimension:  Object.keys(this.props.dimensions)[0],
            selectedRankedItem: '',
            subDimension: this.props.itemsToRankCols[0].name
        }
        
        this.itemsToRank = props.col.categories

     
       
      

        this.handleSelectedDimension = this.handleSelectedDimension.bind(this);
    }
    
    _computeFrequency(itemToRank, data) {

        let freq = 0;
        for (let item of data) {
            if (item.includes(itemToRank)) {
                ++freq
            }
        }

        return {
            item: itemToRank,
            noOfRespondents: freq
        }

    }

    // _computeDimensionCategoryFrequency(item, dimCategory, surveyData) {
    //     if (!surveyData || !this.state.dimension) return []

    //     let noOfRespondents = 0;
    //     for (let row of surveyData) {
    //         if (row[this.props.col.name].includes(item) && row[this.state.dimension].includes(dimCategory)) {
    //             ++noOfRespondents
    //         }
    //     }

    //     return {
    //         item,
    //         dimCat: dimCategory,
    //         col: this.props.col.name,
    //         noOfRespondents: noOfRespondents
    //     }

    // }

    _computeDimensionCategoryFrequency(item, dimCategory, surveyData, itemsToRankCol) {
        if (!surveyData || !this.state.dimension) return []

        let noOfRespondents = 0;
        for (let row of surveyData) {
            // if (row[itemsToRankCol].includes(item) && row[this.state.dimension].includes(dimCategory)) {
            //     ++noOfRespondents
            // }
            if (row[itemsToRankCol] === item && row[this.state.dimension] === dimCategory) {
                ++noOfRespondents
            }
        }

        return {
            item,
            dimCat: dimCategory,
            col: this.itemsToRank,
            noOfRespondents: noOfRespondents
        }

    }

    // computeDimensionCategoryFrequencyDistn(dimCategory, surveyData) {
    //     if (!surveyData) return [];

    //     return this.itemsToRank.map(item => {
    //         return this._computeDimensionCategoryFrequency(item, dimCategory, surveyData)
    //     })
    // }

    computeDimensionCategoryFrequencyDistn(itemsToRank, dimCategory, surveyData, itemsToRankCol) {
        if (!surveyData) return [];

        return itemsToRank.map(item => {
            return this._computeDimensionCategoryFrequency(item, dimCategory, surveyData, itemsToRankCol)
        })
    }


    _computeColumnData(data) {
        if (!data) return []

        return data.map((datum)=> datum[this.props.col.name])
    }
    
    /**
     * 
     * @param {itemsToRank} items to compute distribution for
     * @param {*} data to be used to compute frequency of each item
     */
    _computeOverallFrequencyDist(itemsToRank, data) {
        if (!itemsToRank || !data) return []
        return itemsToRank.map(itemToRank=> {
            return this._computeFrequency(itemToRank, data)
        })
    }

    roundToDp(num, dec) {
       
        if ((typeof num !== 'number') || (typeof dec !== 'number'))
            return false;

        var num_sign = num >= 0 ? 1 : -1;

        return Number( (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec) );
    }

    computeDimensionCategoryProportionDistn(dimensionDist) {
        if (!dimensionDist) return []
        
       // let total = null;
      
        // const totalRespondents = dimensionDist.reduce((total, currDatapoint)=>{
        //         return total +  currDatapoint.noOfRespondents;
        // }, 0)

        const totalRespondents = this.props.data.length;

        return dimensionDist.map((datapoint)=>{
            const percentOfRespondents = totalRespondents > 0 ? this.roundToDp((datapoint.noOfRespondents / totalRespondents) * 100,1) : 0;
            return {
                dimCat: datapoint.dimCat,
                percentOfRespondents,
                item: datapoint.item
            }
            
        })
    
    }


      /**
     * 
     * @param {itemsToRank} items to compute distribution for
     * @param {*} data to be used to compute frequency of each item
     */
    _computeOverallProportionDist(overallFrequencyDistn, data) {
        if (!overallFrequencyDistn || !data) return []
        
       // let total = null;
      
        // const totalRespondents = overallFrequencyDistn.reduce((total, currDatapoint)=>{
        //         return total +  currDatapoint.noOfRespondents ;
        // }, 0)

        const totalRespondents = this.props.data.length;


        return overallFrequencyDistn.map((row)=>{
            const percentOfRespondents = totalRespondents > 0 ? this.roundToDp((row.noOfRespondents / totalRespondents) * 100,1) : 0;
            return {
                item: row.item,
                percentOfRespondents
            }
            
        })
    
    }

   computeSortedChartData(proportionDistnTable) {
        if (!proportionDistnTable) return{};

        const sortedProportionDistnTable = proportionDistnTable.sort((rowA,rowB)=> rowB.percentOfRespondents - rowA.percentOfRespondents)
        const sortedItemsToRank = sortedProportionDistnTable.map((dataPoint, index)=> dataPoint.item)
        const sortedPercentOfRespondents = sortedProportionDistnTable.map(dataPoint=> dataPoint.percentOfRespondents)

        return {
            itemsToRank: sortedItemsToRank,
            percentOfRespondents: sortedPercentOfRespondents
        }
   }

   _computeDimensionOptions(dimensionLabels) {
       let options = [];       
       if (!dimensionLabels) return options;
       
       
       for (let key in dimensionLabels) {
            let dimObj = {}
            dimObj['value'] = key;
            dimObj['label'] = dimensionLabels[key] 
            options.push(dimObj)
       }

       return options
   }

   handleSelectedDimension(index, item) {
       this.setState({subDimension: item.getAttribute('data-value')})
   }

   isDataAvailable(percentOfRespondentsList) {
       if (!percentOfRespondentsList || percentOfRespondentsList.length === 0) return 

       let found = false;
       let  i = 0
       while (!found && i < percentOfRespondentsList.length) {
           if (percentOfRespondentsList[i++] > 0) {
               found = true;
           }
       }

       return found
   }

    render() {
      //  console.log(this.props.isMediumScreen)
        let slidesToShow = 1.05
        const slideIndex = 0;
        let withoutControls = true
        if (this.props.isMediumScreen) {
            slidesToShow = 2.05
            // withoutControls = false
        }

        if (this.props.isLargeScreen) {
            slidesToShow = 3.05
            withoutControls = false
        }

          
        const theme = this.context.theme;
        const headlineStyle = {
            color: theme.color
        }

        const selectedItemsToRankCol =  this.props.itemsToRankCols.find((col)=> col.name === this.state.subDimension)
        console.dir(selectedItemsToRankCol)
       // console.log(slidesToShow)
        const data = this._computeColumnData(this.props.data);
        const overallFrequencyDistnTable = this._computeOverallFrequencyDist(this.itemsToRank, data)
        const overallProportionDistnTable =  this._computeOverallProportionDist(overallFrequencyDistnTable, data)
 
      
        const sortedChartData = this.computeSortedChartData(overallProportionDistnTable)
      
        
        let dimensionCategories = [
            'More',
            'Less',
            "About as much as I expected for this role"
        ];
        
      
        // for (let key in this.props.dimensions[this.state.dimension]) {
        //     dimensionCategories.push(this.props.dimensions[this.state.dimension][key])
        // }        
         

       
        const dimensionCategoryProportionDistnTableList = dimensionCategories.map(dimCategory=>{
            const dimensionCategoryDistnTable = this.computeDimensionCategoryFrequencyDistn(selectedItemsToRankCol.categories, dimCategory, this.props.data, selectedItemsToRankCol.name)
            const dimensionCategoryProportionDistnTable = this.computeDimensionCategoryProportionDistn(dimensionCategoryDistnTable)
            
            const sortedChartData = this.computeSortedChartData(dimensionCategoryProportionDistnTable)
            if (this.isDataAvailable(sortedChartData.percentOfRespondents)) {
                return {
                    dimCategory,
                    itemsSortedByPercent: sortedChartData.itemsToRank,
                    percentOfRespondentsSortedByPercent: sortedChartData.percentOfRespondents
                }
            } else {
                return {
                    dimCategory,
                    itemsSortedByPercent: sortedChartData.itemsToRank,
                    percentOfRespondentsSortedByPercent: [-1]
                }
            }
           
        })


        const dimensionOptions = this._computeDimensionOptions(this.props.dimensionLabels)
       
        return(
            <div className="rankAndMagnitudeChart-container">
                <Headline5 className="headline5">{this.props.dashboardTitle}</Headline5>
                 {/* <Subtitle1 className="subtitle1">Select any data point to see its use and rank broken down by {this.props.dimensionLabels[this.state.subDimension]}</Subtitle1> */}
                <Headline6 className="headline6" style={headlineStyle}>{this.props.overallChartTitle}</Headline6>
                <RankAndMagnitudeChart className="rankAndMagChart home-overallChart" yAxisTitle="Percentage of Respondents" xvalues={sortedChartData.itemsToRank}
                                                chartHeight={'350px'}
                                               selectedRankedItem={''}
                                               colors={['#ff0266' ]}
                                              //  handleSelectedDatapoint={(selectedRankedItem)=>this.setState({selectedRankedItem})}
                                                  handleSelectedDatapoint = {()=>{}}
                                                yvalues={sortedChartData.percentOfRespondents}>
                                                <Headline6 className="headline6">Overall</Headline6>                                                      
                             </RankAndMagnitudeChart>
            
                    <Select
                        className="rankAndMagnitudeChartContainer-select"
                        outlined
                        enhanced
                        label='Break Down By'
                        onEnhancedChange={this.handleSelectedDimension}
                        value={this.state.subDimension}
                        options={dimensionOptions}
                    />
                <Headline6 className="headline6" style={headlineStyle}>{this.props.dimensionChartsTitle} {this.props.dimensionLabels[this.state.subDimension]} </Headline6>                    
                <div className="randAndMagnitudeChart-dimensionChartList">
                  <Carousel key={this.state.dimension} slidesToShow={slidesToShow} cellSpacing={16} slidesToScroll={1} slideIndex={slideIndex} slideWidth={1.0} 
                             dragging swiping withoutControls={withoutControls}>
                    {
                        dimensionCategoryProportionDistnTableList.map((dimCategoryDistnTable, index)=>{
                                                    
                           return (
                                  <React.Fragment key={index}>
                                        <RankAndMagnitudeChart className="rankAndMagChart" yAxisTitle="Percentage of Respondents" xvalues={dimCategoryDistnTable.itemsSortedByPercent} 
                                                                        selectedRankedItem={this.state.selectedRankedItem}
                                                                        chartHeight={'300px'}
                                                                        colors={["#ccc"]}
                                                                        handleSelectedDatapoint={(selectedRankedItem)=>this.setState({selectedRankedItem})}
                                                                       yvalues={dimCategoryDistnTable.percentOfRespondentsSortedByPercent}>
                                                  <Headline6 className="headline6">{dimCategoryDistnTable.dimCategory}</Headline6>                                                      
                                        </RankAndMagnitudeChart>              
                                   </React.Fragment>
                                 )
                            })
                    }
                   </Carousel>
                </div> 
            </div>
        )
    }
}

XDashboardContainer.contextType = ThemeContext;
export default XDashboardContainer;